import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as React from 'react';
import { composeStyles, cssAlignSelf, cssFlex, cssMargin, cssOrder, cssTextTransform, cssWidth } from '@nebula/system-props';
import { typeFontRegularClass, typeSizeSmallClass, typeSizeNormalClass, typeSizeLargeClass } from "@nebula/styles/typography";
import cx from 'classnames';
import "./styles.scss";
var styles = {
  "button": "_3sjFp",
  "size-dynamic": "lJMau",
  "size-default": "_3zn07",
  "size-medium": "_18F8b",
  "size-small": "uxSdp",
  "variant-wireframe": "xCn81",
  "color-primary": "TOjHY",
  "variant-solid": "AHhqR",
  "color-secondary": "_1-4Xn",
  "color-white": "_1qQAl",
  "text": "_2HCeY",
  "icon": "_19rDu"
};

var ButtonRenderFunction = function (props, ref) {
  var text = props.text,
      icon = props.icon,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$size = props.size,
      size = _props$size === void 0 ? 'default' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'solid' : _props$variant,
      disabled = props.disabled,
      onClick = props.onClick,
      dataTestId = props.dataTestId;
  var actualVariant = color === 'secondary' || color === 'white' ? 'wireframe' : variant;
  var actualIcon = icon ? /*#__PURE__*/React.cloneElement(icon, _objectSpread(_objectSpread({}, icon.props), {}, {
    style: _objectSpread(_objectSpread({}, icon.props.style), {}, {
      flex: '0 0 auto'
    })
  })) : null;
  var className = cx(styles.button, styles['size-' + size], styles['variant-' + actualVariant], styles['color-' + color], typeFontRegularClass, size === 'small' ? typeSizeSmallClass : size === 'dynamic' ? typeSizeLargeClass : typeSizeNormalClass);
  var customStyles = composeStyles(props, [cssAlignSelf, size === 'dynamic' && cssFlex, cssMargin, cssOrder, cssTextTransform, size === 'dynamic' && cssWidth]);
  var textClassName = cx(styles.text, _defineProperty({}, styles.icon, Boolean(icon)));
  return /*#__PURE__*/React.createElement("button", {
    ref: ref,
    className: className,
    style: customStyles,
    disabled: disabled,
    onClick: onClick,
    "data-testid": dataTestId
  }, actualIcon, text && /*#__PURE__*/React.createElement("span", {
    className: textClassName
  }, text));
};

export var Button = /*#__PURE__*/React.forwardRef(ButtonRenderFunction);
export default Button;